import React from 'react';
import { observer } from 'mobx-react';
import { Datepicker } from '@this/shared/ui/inputs/datepicker/datepicker';
import { Text as DangerText } from '@this/shared/ui/data_displays/typography';
import type Trip from '@this/domain/trip/trip2';
import type OrderItem from '@this/domain/order_item2';
import type { OrderItemJobTypeKey } from '@this/src/domain/order_item/order_item_job_type';
import { OrderItemJobType, OrderItemJobTypeKeys } from '@this/src/domain/order_item/order_item_job_type';
import { OrderItemStatus, OrderItemStatusAvailable2 } from '@this/domain/order_item/order_item_status';
import moment from '@this/src/lib/moment';

export interface OrderItemBasicInfoFormProps {
  orderItem: OrderItem;
  selectedTrip: Trip;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

const OrderItemBasicInfoForm: React.FC<OrderItemBasicInfoFormProps> = observer(
  ({ orderItem, selectedTrip, classNameForModifiedField }) => {
    return (
      <div style={{ marginBottom: '10px' }}>
        <div style={{ display: 'flex' }}>
          <span style={{ marginRight: '5px' }} className={classNameForModifiedField('jobType')}>
            ジョブタイプ:
          </span>
          <select
            onChange={e => {
              orderItem.jobType = e.target.value as OrderItemJobTypeKey;
            }}
            value={orderItem.jobType}
            style={{ marginBottom: '5px' }}
          >
            {OrderItemJobTypeKeys.map(key => (
              <option key={key} value={key}>
                {OrderItemJobType[key]}
              </option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex' }}>
          <span style={{ marginRight: '5px' }} className={classNameForModifiedField('status')}>
            ステータス:
          </span>
          <select
            value={orderItem.status}
            onChange={e => {
              orderItem.status = parseInt(e.target.value, 10);
            }}
          >
            {OrderItemStatusAvailable2.map(key => (
              <option key={key} value={key}>
                {OrderItemStatus[key]}
              </option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex' }}>
          <span style={{ marginRight: '5px' }} className={classNameForModifiedField('billedAt')}>
            請求対象日:
          </span>
          {selectedTrip.status === 0 ? (
            <DangerText color="danger">
              ※旅程ステータスが「要予約」になるまで請求対象日の入力はできません。
            </DangerText>
          ) : (
            <Datepicker
              value={orderItem.billedAt?.toDate() || undefined}
              onChange={(d: Date | null) => {
                orderItem.billedAt = d ? moment(d) : undefined;
              }}
              dateFormat="YYYY年MM月DD日"
              placeholder="年/月/日"
            />
          )}
        </div>
      </div>
    );
  }
);

export default OrderItemBasicInfoForm;
